<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<div class="title border-bottom-1 mb-2 mt-5 titleblue orderdetails-title">
  <h4 class="m-0 text-black fw-bold">
    Order Details
  </h4>
</div>

<p-table class="orderdetails" #pt [value]="orderDetails" [lazy]="true"  (onLazyLoad)="loadLazy($event)" dataKey="orderDetailId" selectionMode="single"
  [(selection)]="orderDetail" (onRowSelect)="onRowSelect($event)"  [paginator]="showPagination" [rows]="100"
  [rowsPerPageOptions]="[100,150,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
  <ng-template pTemplate="caption">
    <div class="d-block text-end orderdetails-btn">
      <span>
        <!-- travel agent fee -->
        <button pButton pRipple class="p-button" style="background:#6a1b9a;border-color:#6a1b9a;"
          (click)="openPopUpAddTravelAgentFee()">Add Travel Agent Fee</button>
      <app-import-export importEnabled="false" [dataRetrived]="orderDetails" (exportDataSelected)="exportAsExcelFile($event)" [columns]="columns" [importDisabled]="true"></app-import-export>

      <button pButton pRipple class="p-button-outlined"
      (click)="syncPayment()">Sync SL Payment</button>
      <!--		<button pButton pRipple class="p-button-outlined"
    (click)="syncInvoice()">Sync SL Invoice</button>
    -->		<!-- reservation ledger -->
    <button pButton pRipple class="p-button-outlined"(click)="viewOrderDetailTaxes()">View Taxes</button>

    <!-- reservation ledger -->
    <button pButton pRipple class="p-button-outlined"
    (click)="viewReservationLedger()">View Reservation Ledger</button>
    <!--add new-->
    <button pButton pRipple class="p-button-outlined"
    (click)="reGenerateOtaInvoice()">Re-Generate OTA Invoice</button>
    <button pButton pRipple class="p-button-outlined"
    (click)="openPopUpReGenerateInvoice()">Re-Generate Invoice</button>


  </span>
</div>
<div class="d-block text-end orderdetails-btn mt-2">
  <span>
  <button pButton pRipple class="p-button-danger"  (click)="onDeleteByReservationId()">Delete Invoice</button>

  <button pButton pRipple class="p-button"
  (click)="onOpenFormAdd()">New Order Detail +</button>

</span>
</div>
</ng-template>
<ng-template pTemplate="header">
  <tr>
    @for (col of columns; track col) {
      <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
        {{col.header}}
        <!--<p-sortIcon [field]="col.field"></p-sortIcon>-->
      </th>
    }
    <th [ngStyle]="{'width': 'auto'}"></th>
  </tr>
  <!--<tr>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'quantity', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPrice', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAdjustmentAmount', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAdjustmentPercent', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAdjustmentAmount', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
</tr>-->
</ng-template>
<ng-template pTemplate="body" let-orderDetail let-index="rowIndex">
  <tr [pSelectableRow]="orderDetail">
    <td style="white-space: break-spaces; width:100px">{{orderDetail.name}}</td>
    <td>{{orderDetail.quantity}}</td>
    <td style="text-align: right;">{{orderDetail.listPrice | currency : 'USD'}}</td>
    <td style="text-align: right;">{{orderDetail.listPriceAdjustmentAmount | currency : 'USD'}}</td>
    <td style="text-align: right;">{{orderDetail?.subTotal | currency : 'USD'}}</td>
    <td style="text-align: right;">{{orderDetail?.tax | currency : 'USD'}}</td>
    <td style="text-align: right;">{{orderDetail?.total | currency : 'USD'}}</td>
    <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true"
        style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(orderDetail)"></i>
        <!-- 02-26-2025 Divy : Removed Info icon as we are showing in rate log in table -->
        <!-- <i *ngIf="orderDetail.orderProductId == 1" class="pi pi-info-circle" aria-hidden="true" style="color:blue; font-size:110%;"
      (click)="findNightlyRateOpsNotesDetails()"></i> -->
      <!-- <i class="pi pi-info-circle" aria-hidden="true" style="color:blue; font-size:110%;"
    [pTooltip]="tooltipContent" tooltipPosition="right" [escape]="false"></i> -->
  </a>
</span>
</td>
<!-- <td><span style="float:none">
<a>
</a>
</span>
</td> -->
</tr>

@if ((orderDetails.length - 1) == index) {
  <tr>
    <td></td>
    <td></td>
    <td></td>
    <td class="text-end"><b>Total</b></td>
    <td class="text-end"><b>{{totalAmount() | currency : 'USD'}}</b></td>
    <td class="text-end"><b>{{totalTax() | currency : 'USD'}}</b></td>
    <td class="text-end"><b>{{grandTotal() | currency : 'USD'}}</b></td>
    <td></td>
  </tr>
}
<!-- <tr *ngIf="(orderDetails.length - 1) == index">
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
</tr> -->
@if ((orderDetails.length - 1) == index) {
  <tr>
    <td colspan="6" class="text-end"><b>Total Amount</b></td>
    <td class="text-end"><b>{{totalAmount() | currency : 'USD'}}</b></td>
    <td></td>
  </tr>
}
@if ((orderDetails.length - 1) == index) {
  <tr>
    <td colspan="6" class="text-end"><b>Total Taxes</b></td>
    <td  style="text-align: right;"><b>{{totalTax() | currency : 'USD'}}</b></td>
    <td></td>
  </tr>
}
@if ((orderDetails.length - 1) == index) {
  <tr>
    <td colspan="6" style="font-weight: bold;">Grand Total</td>
    <td class="text-end"><b>{{grandTotal() | currency : 'USD'}}</b></td>
    <td></td>
  </tr>
}
</ng-template>
</p-table>

<p-dialog header="ReGenerate Invoice" [(visible)]="reGenerateInvoicePopUp" [style]="{width: 'auto'}">
  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3 mt-3">
      <!-- <input [(ngModel)]="amountReceived" id="amountReceived" type="text"  pInputText> -->
      <p-inputNumber class="w-100 eap-input" [(ngModel)]="amountReceived" id="amountReceived"
        inputId="currency-us" mode="currency" currency="USD" locale="en-US">
      </p-inputNumber>
      <label for="amountReceived">Amount Receieved</label>
    </span>
  </div>
  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3">
      <button pButton class="btn-addt p-button" (click)="reGenerateInvoice()">Submit</button>
    </span>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="addTravelAgentFeePopUp"
  [modal]="true"
  [style]="{width: '580px'}"
  [closable]="true"
  [header]="existingTravelAgentFee ? 'Replace Travel Agent Fee' : 'Add Travel Agent Fee'">

  <div class="ta-fee-dialog">

    <!-- Replace warning -->
    @if (existingTravelAgentFee) {
      <div class="ta-existing-warning">
        <span class="ta-warn-icon">&#9888;</span>
        <div>
          <strong>Existing travel agent fee detected.</strong><br>
          A TRAVEL_AGENT_FEE ledger entry of
          <strong>{{ existingTravelAgentFee.total | currency:'USD' }}</strong>
          already exists on this reservation.
          Submitting will recalculate and replace the existing fee.
        </div>
      </div>
    }

    <!-- Section 1: Select Travel Agent -->
    <div class="ta-section">
      <div class="ta-section-header">1 — Select Travel Agent</div>

      <div class="ta-field">
        <label class="ta-label">Travel Agent Profile <span class="ta-required">*</span></label>
        @if (travelAgentProfilesLoading) {
          <div class="ta-loading">Loading agents...</div>
        } @else {
          <p-dropdown
            [options]="travelAgentProfiles"
            [(ngModel)]="selectedTravelAgent"
            (onChange)="onTravelAgentSelect($event.value)"
            placeholder="— Search by name or agency —"
            [filter]="true"
            filterBy="firstName,lastName,agencyName,iatalicNum"
            [showClear]="true"
            styleClass="w-100">
            <ng-template pTemplate="selectedItem">
              @if (selectedTravelAgent) {
                <span>{{ selectedTravelAgent.firstName }} {{ selectedTravelAgent.lastName }}
                  @if (selectedTravelAgent.agencyName) { — {{ selectedTravelAgent.agencyName }} }
                  @if (selectedTravelAgent.iatalicNum) { (IATA {{ selectedTravelAgent.iatalicNum }}) }
                </span>
              }
            </ng-template>
            <ng-template let-agent pTemplate="item">
              <span>{{ agent.firstName }} {{ agent.lastName }}
                @if (agent.agencyName) { — {{ agent.agencyName }} }
                @if (agent.iatalicNum) { (IATA {{ agent.iatalicNum }}) }
              </span>
            </ng-template>
          </p-dropdown>
        }
        <div class="ta-hint">
          Agent not listed?
          <a href="/travel-agent-profile-list" target="_blank" style="color:#6a1b9a;">Create new agent profile</a>
        </div>
      </div>

      <!-- Agent card (shown after selection) -->
      @if (selectedTravelAgent) {
        <div class="ta-agent-card">
          <div class="ta-kv ta-kv-full">
            <span class="ta-k">Agent Name</span>
            <span class="ta-v">{{ selectedTravelAgent.firstName }} {{ selectedTravelAgent.lastName }}</span>
          </div>
          <div class="ta-kv">
            <span class="ta-k">Agency</span>
            <span class="ta-v">{{ selectedTravelAgent.agencyName || '—' }}</span>
          </div>
          <div class="ta-kv">
            <span class="ta-k">IATA #</span>
            <span class="ta-v">{{ selectedTravelAgent.iatalicNum || '—' }}</span>
          </div>
          <div class="ta-kv">
            <span class="ta-k">ARC #</span>
            <span class="ta-v">{{ selectedTravelAgent.arcNum || '—' }}</span>
          </div>
          <div class="ta-kv">
            <span class="ta-k">Default Commission %</span>
            <span class="ta-v">{{ selectedTravelAgent.defaultCommissionPCT != null ? (selectedTravelAgent.defaultCommissionPCT * 100 | number:'1.0-2') + '%' : '—' }}</span>
          </div>
          <div class="ta-kv">
            <span class="ta-k">W-9 Status</span>
            <span class="ta-v" [ngStyle]="{'color': selectedTravelAgent.w9Status === 'APPROVED' ? '#2e7d32' : selectedTravelAgent.w9Status ? '#e65100' : '#888'}">
              {{ selectedTravelAgent.w9Status === 'APPROVED' ? '&#10003; Approved' : selectedTravelAgent.w9Status || 'Not on file' }}
            </span>
          </div>
        </div>
      }
    </div>

    <!-- Section 2: Commission Terms (shown after agent selected) -->
    @if (selectedTravelAgent) {
      <div class="ta-section">
        <div class="ta-section-header">2 — Commission Terms</div>

        <!-- Mode toggle -->
        <div class="ta-mode-toggle">
          <button type="button" [class.ta-mode-active]="taFeeMode === 'pct'" (click)="taFeeMode = 'pct'; computeTravelAgentFee()">% of Booking Total</button>
          <button type="button" [class.ta-mode-active]="taFeeMode === 'amt'" (click)="taFeeMode = 'amt'; computeTravelAgentFee()">Flat $ Amount</button>
        </div>

        <!-- PCT mode -->
        @if (taFeeMode === 'pct') {
          <div class="ta-row-2">
            <div class="ta-field">
              <label class="ta-label">Commission % <span class="ta-required">*</span></label>
              <div class="ta-input-wrap">
                <input type="number" pInputText [(ngModel)]="taAgentPCT" (input)="computeTravelAgentFee()" min="0" max="50" step="1" class="w-100 ta-pct-input">
                <span class="ta-suffix">%</span>
              </div>
            </div>
            <div class="ta-field">
              <label class="ta-label">Applies to</label>
              <p-dropdown
                [options]="[
                  {label: 'Invoice Grand Total (' + (grandTotal() | currency:'USD') + ')', value: 'grandTotal'},
                  {label: 'Invoice Sub Total (' + (totalAmount() | currency:'USD') + ')', value: 'subTotal'},
                  {label: 'Nightly Rate Only', value: 'nightlyOnly'}
                ]"
                [(ngModel)]="taFeeBase"
                (onChange)="computeTravelAgentFee()"
                styleClass="w-100">
              </p-dropdown>
            </div>
          </div>
        }

        <!-- Flat $ mode -->
        @if (taFeeMode === 'amt') {
          <div class="ta-field">
            <label class="ta-label">Commission Amount <span class="ta-required">*</span></label>
            <div class="ta-input-wrap">
              <span class="ta-prefix">$</span>
              <input type="number" pInputText [(ngModel)]="taAgentAMT" (input)="taComputedAmt = taAgentAMT; computeTravelAgentFee()" min="0" step="0.01" class="w-100 ta-amt-input" placeholder="e.g. 350.00">
            </div>
          </div>
        }

        <!-- Live calculator -->
        <div class="ta-calc-box">
          <div class="ta-calc-row">
            <span class="ta-calc-label">Booking Base</span>
            <span class="ta-calc-value">{{ taFeeMode === 'pct' ? (getTaFeeBase() | currency:'USD') : '(flat amount)' }}</span>
          </div>
          <div class="ta-calc-row">
            <span class="ta-calc-label">Commission Rate</span>
            <span class="ta-calc-value">{{ taFeeMode === 'pct' ? (taAgentPCT + '%') : 'N/A' }}</span>
          </div>
          <hr class="ta-calc-divider">
          <div class="ta-calc-row ta-calc-total">
            <span class="ta-calc-label">Commission Due to Agent</span>
            <span class="ta-calc-value">{{ taComputedAmt | currency:'USD' }}</span>
          </div>
          @if (getTaNights() > 0) {
            <div class="ta-calc-row ta-calc-small">
              <span>Per night ({{ getTaNights() }} nights)</span>
              <span>{{ (taComputedAmt / getTaNights()) | currency:'USD' }} / night</span>
            </div>
          }
        </div>

        <div class="ta-info-chip">
          <i class="pi pi-info-circle" style="color:#f9a825"></i>
          Commission is recorded as a negative adjustment and added to the
          <strong>TRAVEL_AGENT_FEE</strong> ledger entry. It does not change the guest-facing invoice total.
        </div>
      </div>

      <!-- Section 3: Notes -->
      <div class="ta-section">
        <div class="ta-section-header">3 — Notes</div>
        <div class="ta-field">
          <label class="ta-label">Private Notes (internal only)</label>
          <textarea pInputTextarea [(ngModel)]="taPrivateNotes" rows="3" class="w-100"
            placeholder="e.g. Referred via Virtuoso network. Commission due within 30 days of guest checkout."></textarea>
        </div>
      </div>
    }

  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-text" (click)="addTravelAgentFeePopUp = false">Cancel</button>
    <button pButton
      [disabled]="!selectedTravelAgent || taComputedAmt <= 0"
      [style]="{'background': existingTravelAgentFee ? '#e65100' : '#6a1b9a', 'border-color': existingTravelAgentFee ? '#e65100' : '#6a1b9a'}"
      (click)="formAddTravelAgentFee()">
      {{ existingTravelAgentFee ? 'Replace Travel Agent Fee' : 'Apply Travel Agent Fee' }}
    </button>
  </ng-template>
</p-dialog>

  <!-- Composite Password Dialog -->
  <p-dialog header="Authorization Required"
    [(visible)]="compositePasswordDialogVisible"
    [modal]="true"
    [style]="{width: '380px'}"
    [closable]="true">
    <div class="col-lg-12">
      <p class="mb-3 mt-2">This listing requires a password to perform add, update, or delete operations.</p>
      <span class="p-float-label required-field w-100 mb-3 mt-3">
        <input id="compositePassword" type="password" pInputText
          [(ngModel)]="compositePasswordValue" class="w-100"
          (keyup.enter)="onCompositePasswordConfirm()" />
        <label for="compositePassword">Password</label>
      </span>
      <div *ngIf="compositePasswordError" class="p-error mb-2">{{ compositePasswordError }}</div>
    </div>
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" (click)="onCompositePasswordCancel()">Cancel</button>
          <button pButton class="btn-addt p-button" (click)="onCompositePasswordConfirm()">Confirm</button>
        </div>
      </div>
    </div>
  </p-dialog>

  <p-dialog
    header="Rate Details"
    [modal]="true"
    [(visible)]="showOpsNoteDialog"
    [style]="{ width: '100rem', height:'100rem' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [maximizable]="true">
    <!-- <p-table
    [value]="opsNoteDetails"
    styleClass="p-datatable-gridlines"
    [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="header">
      <tr>
        <th>CheckIn</th>
        <th>CheckOut</th>
        <th>Nights</th>
        <th>Price</th>
        <th>Ops Notes</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-opsNoteDetail>
      <tr>
        <td>{{ opsNoteDetail.checkInDate }}</td>
        <td>{{ opsNoteDetail.checkOutDate }}</td>
        <td>{{ opsNoteDetail.numNights }}</td>
        <td>{{ opsNoteDetail.yieldPriceAMT }}</td>
        <td>{{ opsNoteDetail.opsNotes }}</td>
      </tr>
    </ng-template>
  </p-table> -->
  <div class="p-4">

    @for (opsNoteDetail of opsNoteDetails; track opsNoteDetail) {
      <table>
        <tr>
          <div class="d-flex">
            <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold; ">Property :</span>
            <span>{{opsNoteDetail.propertyCode}}</span>
          </div>
        </tr>
        <tr>
          <div class="d-flex">
            <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold; ">CheckIn :</span>
            <span>{{opsNoteDetail.checkInDate != null ? opsNoteDetail.checkInDate : checkInDate | date: 'yyyy-MM-dd'}}</span>
          </div>
        </tr>
        <tr>
          <div class="d-flex">
            <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold;">CheckOut :</span>
            <span>{{opsNoteDetail.checkOutDate != null ? opsNoteDetail.checkOutDate : checkOutDate | date: 'yyyy-MM-dd'}}</span>
          </div>
        </tr>
        <tr>
          <div class="d-flex">
            <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold;">Nights :</span>
            <span>{{opsNoteDetail.numNights}}</span>
          </div>
        </tr>
        <tr>
          <div class="d-flex">
            <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold;">List Price :</span>
            <span>{{opsNoteDetail.listPriceAMT | currency:'USD'}}</span><span>&nbsp; {{opsNoteDetail.listPriceAMT != null ? '(' : ''}} {{opsNoteDetail.listPriceAMT | currency:'USD'}} {{opsNoteDetail.listPriceAMT != null ? '/' : ''}} {{opsNoteDetail.numNights}} {{opsNoteDetail.listPriceAMT != null ? '=' : ''}} {{(opsNoteDetail.listPriceAMT / opsNoteDetail.numNights) | currency:'USD'}} {{opsNoteDetail.listPriceAMT != null ? ')' : ''}}</span>
          </div>
        </tr>
        <tr>
          <div class="d-flex">
            <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold;">Original Yield Price :</span>
            <span>{{opsNoteDetail.yieldPriceOrigAMT | currency:'USD'}}</span><span>&nbsp; {{opsNoteDetail.yieldPriceOrigAMT != null ? '(' : ''}} {{opsNoteDetail.yieldPriceOrigAMT | currency:'USD'}} {{opsNoteDetail.yieldPriceOrigAMT != null ? '/' : ''}} {{opsNoteDetail.numNights}} {{opsNoteDetail.yieldPriceOrigAMT != null ? '=' : ''}}  {{(opsNoteDetail.yieldPriceOrigAMT / opsNoteDetail.numNights) | currency:'USD'}} {{opsNoteDetail.yieldPriceOrigAMT != null ? ')' : ''}}</span>
          </div>
        </tr>
        <tr>
          <div class="d-flex">
            <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold;">Final Yield Price :</span>
            <span>{{opsNoteDetail.yieldPriceAMT | currency:'USD'}}</span><span>&nbsp; {{opsNoteDetail.yieldPriceAMT != null ? '(' : ''}} {{opsNoteDetail.yieldPriceAMT | currency:'USD'}} {{opsNoteDetail.yieldPriceAMT != null ? '/' : ''}} {{opsNoteDetail.numNights}} {{opsNoteDetail.yieldPriceAMT != null ? '=' : ''}} {{(opsNoteDetail.yieldPriceAMT / opsNoteDetail.numNights) | currency:'USD'}} {{opsNoteDetail.yieldPriceAMT != null ? ')' : ''}}</span>
          </div>
        </tr>
        <tr>
          <td style="min-width: 250px;padding-right:10px; padding-top: 10px; text-align:left; font-weight: bold;">
            <div class="d-flex gap-2">
              <a class="wiki-list-btn" href="javascript:void(0);" (click)="redirectToProperty(opsNoteDetail, 2)">Property</a>
              <a class="wiki-list-btn" href="javascript:void(0);" (click)="redirectToProperty(opsNoteDetail, 3)">Rate</a>
              <a class="wiki-list-btn" href="javascript:void(0);" (click)="redirectToProperty(opsNoteDetail, 4)">Seasons</a>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2"><br><br><hr></td>
        </tr>
        @if (opsNoteDetail.logOutput) {
          <tr>
            <td colspan="2" style="white-space: pre-line;"><pre>{{opsNoteDetail.logOutput}}</pre></td>
          </tr>
        }
        @if (opsNoteDetail.opsNotes) {
          <tr>
            <td colspan="2" style="white-space: pre-line;"><pre>{{opsNoteDetail.opsNotes}}</pre></td>
          </tr>
        }
        @if (!opsNoteDetail.opsNotes) {
          <tr>
            <td colspan="2" style="white-space: pre-line;"><pre>Dynamic pricing adjustments not available</pre></td>
          </tr>
        }
      </table>
    }
  </div>
</p-dialog>
